// import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainLayout from "./main_layout"; // Create MainLayout.js inside "pages" folder
// import About from "./utils/about"; // Create About.js inside "pages" folder
import "../styles/App.css";

import { ItemsProvider } from "../contexts/item_context"; // ✅ import provider here


function App() {
  return (
    <ItemsProvider>


      <Router>
        <Routes>
          <Route path="/" element={<MainLayout />} />
          {/* <Route path="/about" element={<About />} /> */}
        </Routes>
      </Router>
    </ItemsProvider>
  );
}

export default App;
